import './ChatIntegration.scss';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import EhtGroupLogo from '../assets/logo-color-square.png';
import { Helmet } from 'react-helmet';

declare global {
  interface Window {
    fcWidget: any;
    fcSettings: any;
  }
}

export default function ChatIntegration () {
  const user: any = useSelector((state: any) => state.authentication.get('user'));
  const client: any = useSelector((state: any) => state.authentication.get('client'));
  const clients: any = useSelector((state: any) => state.authentication.get('clients'));
  const hsIdentificationAccessToken: any = useSelector((state: any) => state.authentication.get('hsIdentificationAccessToken'));

  useEffect(() => {
    if (!import.meta.env.REACT_APP_FRESHCHAT_TOKEN) return;

    function setUserProperties () {
      window.fcWidget.user.setProperties({
        cf_environment: import.meta.env.MODE,
        cf_app_version: import.meta.env.REACT_APP_FOX_RELEASE_HASH,
      });

      if (client) {
        window.fcWidget.user.setProperties({
          cf_current_client_id: client.get('id'),
          cf_current_client_name: client.get('name'),
        });
      }

      if (clients) {
        const clientIds = clients
          .filter((c: any) => c?.get)
          .map((c: any) => c.get('id'))
          .join(', ');
        window.fcWidget.user.setProperties({ cf_clients: clientIds });
      }

      if (user) {
        const userId = user.get('id');
        const email = user.get('email');
        const firstName = user.get('first_name');
        const lastName = user.get('last_name');

        if (userId) window.fcWidget.setExternalId(userId);

        const props: Record<string, string> = {};
        if (userId) props.cf_user_id = userId;
        if (email) props.email = email;
        if (firstName) props.firstName = firstName;
        if (lastName) props.lastName = lastName;
        if (Object.keys(props).length) window.fcWidget.user.setProperties(props);
      }
    }

    if (window.fcWidget?.isInitialized()) {
      setUserProperties();
    } else {
      window.fcSettings = {
        ...window.fcSettings,
        config: {
          headerProperty: { appLogo: EhtGroupLogo },
          agent: { hideBio: true },
        },
        onInit: setUserProperties,
      };
    }
  }, [user, client, clients]);

  function renderFreshchat () {
    const widgetId = import.meta.env.REACT_APP_FRESHCHAT_TOKEN;
    const cdnUrl = import.meta.env.REACT_APP_FRESHCHAT_CDN_URL;
    if (!widgetId || !cdnUrl) return null;

    return (
      <Helmet>
        <script src={cdnUrl} {...{ chat: 'true', widgetId }} />
      </Helmet>
    );
  }

  function renderHubspotChat () {
    if (import.meta.env.REACT_APP_HUBSPOTCHAT_SCRIPT) {
      if (hsIdentificationAccessToken) {
        window['hsConversationsSettings'] = {
          identificationEmail: user.get('email'),
          identificationToken: hsIdentificationAccessToken
        };
      }

      return (<Helmet>
        <script type="text/javascript" id="hs-script-loader" async defer src={import.meta.env.REACT_APP_HUBSPOTCHAT_SCRIPT}></script>
      </Helmet>);
    }

    return null;
  }

  return (<>
    {renderHubspotChat()}
    {renderFreshchat()}
  </>);
}
